export default function initials(name: string = "Unknown") {
  const parts = name.split(' ');
  if (parts.length > 1) {
    return parts[0].substr(0, 1) + parts[parts.length - 1].substr(0, 1);
  } else {
    return name.substr(0, 2);
  }
}